module.exports = __webpack_public_path__ + "static/media/screenshot.0d7c59ed.png";